import type { RouteRecordRaw } from 'vue-router'

export const approvalRoutes: RouteRecordRaw[] = [
  {
    path: '/approvals',
    name: 'approvals',
    component: () => import('@/modules/post-mvp/approval/views/ApprovalsView.vue'),
    meta: {
      title: 'Согласования',
      requiresAuth: true,
    },
  },
]

export function createApprovalRoutes() {
  return approvalRoutes
}
